//node_modules
import React from "react";
import { NextPage } from "next";

import type { PageProps } from "./types";

//layout
import SiteLayout from "src/layouts/SiteLayout";

//locals
import BlogComponent from "./components/BlogComponent";
import PagingComponent from "./components/RouterComponent";
import MetaComponent from "./components/MetadataComponent";

const BlogsListPage: NextPage<PageProps> = ({ page, total, blogs }) => {
  return (
    <SiteLayout>
      <MetaComponent />
      <BlogComponent blogs={blogs} />
      <PagingComponent page={page} total={total} />
    </SiteLayout>
  );
};

export default BlogsListPage;
